"use strict";
const { each, includes, uniq, map, chain } = require('lodash');
const { ATTRIBUTE_TYPE } = require('./attributesConst');
const METADATA_FIELDS = ['displayType', 'formatSettings', 'type'];
const getAttributesOrMetricsDisplayType = (attributeOrMetrics, configDefinition) => {
    if (attributeOrMetrics.attributeId) {
        return attributeOrMetrics.type;
    }
    if (attributeOrMetrics.metricId) {
        const metricDefinition = configDefinition.find(({ id }) => id === attributeOrMetrics.metricId);
        return metricDefinition?.display_type;
    }
    return attributeOrMetrics?.displayType;
};
const getMetadataTypeForAttributeAndMetric = (field, metadataChainFieldToChain) => {
    const { type } = metadataChainFieldToChain;
    if (type?.toLowerCase().includes(ATTRIBUTE_TYPE.CURRENCY)) {
        return ATTRIBUTE_TYPE.CURRENCY;
    }
    return field.type;
};
const setMetadataToFields = ({ attributes = [], metrics = [], attributeAndMetricsIds = [], metricsConfig, attributesMetadata }) => {
    if (!attributeAndMetricsIds.length) {
        return;
    }
    const metaDataResponse = attributesMetadata.map((attributeOrMetrics) => ({ ...attributeOrMetrics, displayType: getAttributesOrMetricsDisplayType(attributeOrMetrics, metricsConfig) }));
    const { metaDataForAttributes, metaDataForMetrics } = metaDataResponse.reduce((res, metaData) => {
        const metadataKey = metaData.attributeId ? 'metaDataForAttributes' : 'metaDataForMetrics';
        return { ...res, [metadataKey]: [...res[metadataKey], metaData] };
    }, { metaDataForAttributes: [], metaDataForMetrics: [] });
    each(attributes, (field) => {
        const fieldWithMetaData = chain(metaDataForAttributes).find({ attributeId: field.attribute }).pick(METADATA_FIELDS).value();
        Object.assign(field, fieldWithMetaData, { type: getMetadataTypeForAttributeAndMetric(field, fieldWithMetaData) });
    });
    each(metrics, (field) => {
        const fieldWithMetaData = chain(metaDataForMetrics).find({ metricId: field.metric }).pick(METADATA_FIELDS).value();
        Object.assign(field, fieldWithMetaData, { type: getMetadataTypeForAttributeAndMetric(field, fieldWithMetaData) });
    });
};
const fieldIsAttribute = (field) => (includes([ATTRIBUTE_TYPE.DATA_ATTRIBUTE, ATTRIBUTE_TYPE.STRING_ATTRIBUTE, ATTRIBUTE_TYPE.NUMBER_ATTRIBUTE, ATTRIBUTE_TYPE.SIMPLE_DATE_ATTRIBUTE], field.type));
const getOnlyFieldsThatNeedMetadata = (fields = []) => {
    const { attributes, metrics } = fields.reduce(({ attributes: attributesRes, metrics: metricsRes }, field) => {
        if (fieldIsAttribute(field) && includes([ATTRIBUTE_TYPE.NUMBER_ATTRIBUTE], field.type)) {
            return { attributes: [...attributesRes, field], metrics: metricsRes };
        }
        if (!fieldIsAttribute(field) && field._extra && includes([ATTRIBUTE_TYPE.NUMBER], field._extra.format_type)) {
            return { attributes: attributesRes, metrics: [...metricsRes, field] };
        }
        return { attributes: attributesRes, metrics: metricsRes };
    }, { attributes: [], metrics: [] });
    const attributeAndMetricsIds = [].concat(uniq(map(attributes, 'attribute')), uniq(map(metrics, 'metric')));
    return { attributes, metrics, attributeAndMetricsIds };
};
module.exports = {
    fieldIsAttribute,
    getOnlyFieldsThatNeedMetadata,
    setMetadataToFields,
};
//# sourceMappingURL=attributeMetricsMetadata.js.map